import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'lumiron-section-title',
  templateUrl: 'section-title.component.html',
  styleUrl: './section-title.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class SectionTitleComponent {}
